export const AMOUNT_INSURED_FORMAT = '0,0';
export const AMOUNT_DEFAULT_FORMAT = '0,0.00';
